import React, { useState, useEffect } from 'react';
import { useApp } from '../context/AppContext';
import { getAppTrialApplications } from '../services/api';

const statusBadge = s => ({ accepted:'badge badge-green', pending:'badge badge-amber', rejected:'badge badge-red' })[s] || 'badge badge-gray';

export default function TrialApplications({ toast }) {
  const { token } = useApp();
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(null);

  const load = async (p=1) => {
    setLoading(true);
    try { const res = await getAppTrialApplications(token, { page:p, limit:20 }); setApps(res.data||[]); setPagination(res.pagination||null); }
    catch(e) { toast?.(e.message,'error'); } finally { setLoading(false); }
  };

  useEffect(()=>{ load(); },[token]);

  return (
    <div>
      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">Total applications</div><div className="stat-value">{pagination?.total??apps.length}</div><div className="stat-sub">All applications</div></div>
        <div className="stat-card"><div className="stat-label">Pending</div><div className="stat-value">{apps.filter(a=>a.invitationStatus==='pending').length}</div><div className="stat-sub">Awaiting review</div></div>
        <div className="stat-card"><div className="stat-label">Accepted</div><div className="stat-value">{apps.filter(a=>a.invitationStatus==='accepted').length}</div><div className="stat-sub stat-up">Approved</div></div>
        <div className="stat-card"><div className="stat-label">Rejected</div><div className="stat-value">{apps.filter(a=>a.invitationStatus==='rejected').length}</div><div className="stat-sub">Declined</div></div>
      </div>
      <div className="card" style={{ padding:0 }}>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Player</th><th>Club</th><th>Position</th><th>Status</th><th>Applied</th></tr></thead>
            <tbody>
              {loading ? <tr><td colSpan={5} style={{ textAlign:'center', padding:40, color:'var(--text-dim)' }}>Loading applications…</td></tr>
              : apps.length===0 ? <tr><td colSpan={5} style={{ textAlign:'center', padding:40, color:'var(--text-dim)' }}>No trial applications yet</td></tr>
              : apps.map(a=>(
                <tr key={a.id}>
                  <td><div style={{ fontWeight:500 }}>{a.playerName||a.playerId}</div><div style={{ fontSize:11, color:'var(--text-dim)' }}>{a.playerEmail||''}</div></td>
                  <td style={{ fontSize:12 }}>{a.clubName||a.clubId||'—'}</td>
                  <td style={{ fontSize:12 }}>{a.position||'—'}</td>
                  <td><span className={statusBadge(a.invitationStatus)}>{a.invitationStatus}</span></td>
                  <td style={{ fontSize:12, color:'var(--text-dim)' }}>{a.createdAt?new Date(a.createdAt).toLocaleDateString():'—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {pagination?.totalPages>1 && (
        <div style={{ display:'flex', gap:8, justifyContent:'center', marginTop:16 }}>
          <button className="btn btn-ghost" disabled={page<=1} onClick={()=>{setPage(p=>p-1);load(page-1);}}>← Prev</button>
          <span style={{ padding:'8px 14px', fontSize:13, color:'var(--text-muted)' }}>Page {page} / {pagination.totalPages}</span>
          <button className="btn btn-ghost" disabled={page>=pagination.totalPages} onClick={()=>{setPage(p=>p+1);load(page+1);}}>Next →</button>
        </div>
      )}
    </div>
  );
}
